function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 9.14285714 0 9.14285714 9.14262857 0 9.14262857"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5B9A\\u7A3F",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u9F99\\u8725\\u5B9E\\u9A8C\\u5BA4",
  transform: "translate(-687.000000, -1359.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-7",
  transform: "translate(0.000000, 1166.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u955C\\u50CF\\u670D\\u52A1",
  transform: "translate(687.000000, 193.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#EBECEC",
  fillRule: "nonzero",
  points: "4.79577143 60.8205714 3.17977143 59.2045714 59.2037714 3.17942857 60.8197714 4.79657143"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#A1CDF4",
  fillRule: "nonzero",
  points: "32 64 64 64 64 32 32 32"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  fill: "#A1CDF4",
  fillRule: "nonzero",
  points: "0 32 32 32 32 0 0 0"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#1C8AEC",
  fillRule: "nonzero",
  points: "16 48 48 48 48 16 16 16"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4",
  transform: "translate(0.000000, 0.000229)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40,32 C40,36.4182857 36.4182857,40 32,40 C27.5817143,40 24,36.4182857 24,32 C24,27.5817143 27.5817143,24 32,24 C36.4182857,24 40,27.5817143 40,32",
  id: "Fill-6",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36,32 C36,34.2091429 34.2091429,36 32,36 C29.7908571,36 28,34.2091429 28,32 C28,29.7897143 29.7908571,28 32,28 C34.2091429,28 36,29.7897143 36,32",
  id: "Fill-8",
  fill: "#181818",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64,4.57142857 C64,7.096 61.9531429,9.14285714 59.4285714,9.14285714 C56.904,9.14285714 54.8571429,7.096 54.8571429,4.57142857 C54.8571429,2.04685714 56.904,0 59.4285714,0 C61.9531429,0 64,2.04685714 64,4.57142857",
  id: "Fill-10",
  fill: "#1C8AEC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 54.857143)",
  id: "Fill-12-Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.14285714,4.57142857 C9.14285714,7.096 7.096,9.14285714 4.57142857,9.14285714 C2.04685714,9.14285714 0,7.096 0,4.57142857 C0,2.04685714 2.04685714,0 4.57142857,0 C7.096,0 9.14285714,2.04685714 9.14285714,4.57142857",
  id: "Fill-12",
  fill: "#1C8AEC",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})))))));

function SvgDecorativeIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u955C\u50CF\u670D\u52A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeIcon3);
export default __webpack_public_path__ + "static/media/decorative-icon-3.61c29cc5.svg";
export { ForwardRef as ReactComponent };